import { useSyncExternalStore } from "react";

/** Live boolean for a CSS media query (keeps layout logic and CSS breakpoints in agreement). */
export function useMedia(query: string): boolean {
  return useSyncExternalStore(
    (notify) => {
      const mql = window.matchMedia(query);
      mql.addEventListener("change", notify);
      return () => mql.removeEventListener("change", notify);
    },
    () => window.matchMedia(query).matches,
    () => false,
  );
}
